// キャッシュにQRコード読込履歴がある場合はスタンプ獲得
export const getCacheQrcode = () => {
  const qrcode = localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-qrcode`)

  if (qrcode) location.href = qrcode
  return
}
